
import { BlogPost } from "@/types/blog";
import { content } from "./content";

export const KryptoSteuerKlarheit: BlogPost = {
  title: "Klarheit im Krypto-Steuerdschungel: Was Privatanleger jetzt wissen sollten",
  metaTitle: "Krypto & Steuern: Was Anleger wissen müssen",
  slug: "krypto-steuer-klarheit",
  excerpt: "Steuerliche Klarheit für Krypto-Investoren: BMF-Schreiben zur Besteuerung von Bitcoin & Co. und emotionale Faktoren bei Finanzentscheidungen.",
  date: "10.03.2025",
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  
  category: "Technologie & Systeme",
  tags: ["Kryptowährungen", "Steuern", "Bitcoin", "BMF", "Finanzentscheidungen"],
  imageUrl: "/images/blog/krypto-steuer.jpg",
  content
};
